import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Göktürk Mahallesi Halı Yıkama",
    path: "/eyupsultan/gokturk-hali-yikama",
    description:
      "Eyüpsultan Göktürk Mahallesi’nde halılarınızı el değmeden hijyenik şekilde temizliyor, aynı gün teslim ediyoruz."
  },
  {
    label: "Alibeyköy Halı Yıkama",
    path: "/eyupsultan/alibeykoy-hali-yikama",
    description:
      "Alibeyköy semtinde bireysel ve ticari müşterilere özel halı yıkama hizmeti sunuyor, kapıdan teslim sağlıyoruz."
  },
  {
    label: "Rami Mahallesi Halı Yıkama",
    path: "/eyupsultan/rami-hali-yikama",
    description:
      "Rami Mahallesi’nde halılarınız çevre dostu ürünlerle yıkanır, modern sistemlerle güvenle temizlenir."
  },
  {
    label: "İslambey Mahallesi Halı Yıkama",
    path: "/eyupsultan/islambey-hali-yikama",
    description:
      "İslambey Mahallesi’nde antibakteriyel deterjanlarla halı yıkama hizmeti sunuyoruz, hijyen garantili."
  },
  {
    label: "Çırçır Mahallesi Halı Yıkama",
    path: "/eyupsultan/circir-hali-yikama",
    description:
      "Çırçır Mahallesi’nde halılarınızı özenle yıkayıp steril paketlerde kısa sürede teslim ediyoruz."
  },
  {
    label: "Karadolap Mahallesi Halı Yıkama",
    path: "/eyupsultan/karadolap-hali-yikama",
    description:
      "Karadolap Mahallesi’nde halı yıkama işlemleriniz modern makinelerle, tam hijyen garantisiyle yapılır."
  },
  {
    label: "Yeşilpınar Mahallesi Halı Yıkama",
    path: "/eyupsultan/yesilpinar-hali-yikama",
    description:
      "Yeşilpınar Mahallesi’nde halılarınızı evinizden alıyor, profesyonelce temizleyip zamanında geri getiriyoruz."
  }
];

const EyupsultanSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">EYÜPSULTAN SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EyupsultanSidebar;
